import { render, staticRenderFns } from "./ProductAndAmount.vue?vue&type=template&id=690ef520&"
import script from "./ProductAndAmount.vue?vue&type=script&lang=ts&"
export * from "./ProductAndAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports